import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { catalogTranslationRef } from '@backstage/plugin-catalog/alpha';

export const catalogFr = createTranslationMessages({
  ref: catalogTranslationRef,
  full: true,
  messages: {
    'deleteEntity.description':
      "Cette entité n'est référencée par aucun emplacement et ne reçoit donc pas de mises à jour. Cliquez ici pour la supprimer.",
    'deleteEntity.cancelButtonTitle': 'Annuler',
    'deleteEntity.deleteButtonTitle': 'Supprimer',
    'deleteEntity.dialogTitle':
      'Voulez-vous vraiment supprimer cette entité ?',
    'deleteEntity.actionButtonTitle': "Supprimer l'entité",
    'indexPage.title': 'Catalogue {{orgName}}',
    'indexPage.createButtonTitle': 'Créer',
    'indexPage.supportButtonContent':
      'Toutes les entités de votre catalogue logiciel',
    'aboutCard.title': 'À propos',
    'aboutCard.unknown': 'inconnu',
    'aboutCard.refreshButtonTitle': "Planifier l'actualisation de l'entité",
    'aboutCard.refreshButtonAriaLabel': 'Actualiser',
    'aboutCard.editButtonTitle': 'Modifier les métadonnées',
    'aboutCard.editButtonAriaLabel': 'Modifier',
    'aboutCard.createSimilarButtonTitle': 'Créer quelque chose de similaire',
    'aboutCard.refreshScheduledMessage': 'Actualisation planifiée',
    'aboutCard.launchTemplate': 'Lancer le modèle',
    'aboutCard.viewTechdocs': 'Voir la TechDocs',
    'aboutCard.viewSource': 'Voir le code source',
    'aboutCard.descriptionField.value': 'Aucune description',
    'aboutCard.descriptionField.label': 'Description',
    'aboutCard.ownerField.value': 'Aucun propriétaire',
    'aboutCard.ownerField.label': 'Propriétaire',
    'aboutCard.domainField.value': 'Aucun domaine',
    'aboutCard.domainField.label': 'Domaine',
    'aboutCard.systemField.value': 'Aucun système',
    'aboutCard.systemField.label': 'Système',
    'aboutCard.parentComponentField.value': 'Aucun composant parent',
    'aboutCard.parentComponentField.label': 'Composant parent',
    'aboutCard.typeField.label': 'Type',
    'aboutCard.kindField.label': 'Nature',
    'aboutCard.lifecycleField.label': 'Cycle de vie',
    'aboutCard.tagsField.value': 'Aucun tag',
    'aboutCard.tagsField.label': 'Tags',
    'aboutCard.targetsField.label': 'Cibles',
    'searchResultItem.type': 'Type',
    'searchResultItem.kind': 'Nature',
    'searchResultItem.lifecycle': 'Cycle de vie',
    'searchResultItem.owner': 'Propriétaire',
    'catalogTable.warningPanelTitle':
      'Impossible de récupérer les entités du catalogue.',
    'catalogTable.viewActionTitle': 'Voir',
    'catalogTable.editActionTitle': 'Modifier',
    'catalogTable.starActionTitle': 'Ajouter aux favoris',
    'catalogTable.unStarActionTitle': 'Retirer des favoris',
    'catalogTable.allFilters': 'Tous',
    'dependencyOfComponentsCard.title': 'Dépendance des composants',
    'dependencyOfComponentsCard.emptyMessage':
      'Aucun composant ne dépend de ce composant',
    'dependsOnComponentsCard.title': 'Dépend des composants',
    'dependsOnComponentsCard.emptyMessage':
      "Aucun composant n'est une dépendance de ce composant",
    'dependsOnResourcesCard.title': 'Dépend des ressources',
    'dependsOnResourcesCard.emptyMessage':
      "Aucune ressource n'est une dépendance de ce composant",
    'entityContextMenu.copiedMessage': 'Copié !',
    'entityContextMenu.moreButtonTitle': 'Plus',
    'entityContextMenu.moreButtonAriaLabel': "Plus d'actions",
    'entityContextMenu.inspectMenuTitle': "Inspecter l'entité",
    'entityContextMenu.copyURLMenuTitle': "Copier l'URL de l'entité",
    'entityContextMenu.unregisterMenuTitle': "Désinscrire l'entité",
    'entityLabelsCard.title': 'Labels',
    'entityLabelsCard.emptyDescription':
      "Aucun label défini pour cette entité. Vous pouvez ajouter des labels au YAML de votre entité comme dans l'exemple mis en évidence ci-dessous :",
    'entityLabelsCard.readMoreButtonTitle': 'En savoir plus',
    'entityLabelsCard.columnKeyLabel': 'Label',
    'entityLabelsCard.columnValueLabel': 'Valeur',
    'entityLabels.warningPanelTitle': 'Entité introuvable',
    'entityLabels.ownerLabel': 'Propriétaire',
    'entityLabels.lifecycleLabel': 'Cycle de vie',
    'entityLabels.domainLabel': 'Domaine',
    'entityLabels.systemLabel': 'Système',
    'entityLabels.partOfLabel': 'Fait partie de',
    'entityLinksCard.title': 'Liens',
    'entityLinksCard.emptyDescription':
      "Aucun lien défini pour cette entité. Vous pouvez ajouter des liens au YAML de votre entité comme dans l'exemple mis en évidence ci-dessous :",
    'entityLinksCard.readMoreButtonTitle': 'En savoir plus',
    'entityNotFound.title': "L'entité est introuvable",
    'entityNotFound.description':
      'Vous voulez nous aider à construire cela ? Consultez notre documentation de démarrage.',
    'entityNotFound.docButtonTitle': 'DOCS',
    'entityPage.notFoundMessage':
      "Il n'existe aucune entité {{kind}} avec {{link}} demandé(e).",
    'entityPage.notFoundLinkText':
      "la nature, l'espace de noms et le nom",
    'entityTabs.tabsAriaLabel': 'Onglets',
    entityProcessingErrorsDescription: "L'erreur ci-dessous provient de",
    entityRelationWarningDescription:
      "Cette entité a des relations vers d'autres entités qui sont introuvables dans le catalogue.\n Les entités introuvables sont : ",
    'hasComponentsCard.title': 'Contient des composants',
    'hasComponentsCard.emptyMessage':
      'Aucun composant ne fait partie de ce système',
    'hasResourcesCard.title': 'Contient des ressources',
    'hasResourcesCard.emptyMessage':
      'Aucune ressource ne fait partie de ce système',
    'hasSubcomponentsCard.title': 'Contient des sous-composants',
    'hasSubcomponentsCard.emptyMessage':
      'Aucun sous-composant ne fait partie de ce composant',
    'hasSubdomainsCard.title': 'Contient des sous-domaines',
    'hasSubdomainsCard.emptyMessage':
      'Aucun sous-domaine ne fait partie de ce domaine',
    'hasSystemsCard.title': 'Contient des systèmes',
    'hasSystemsCard.emptyMessage':
      'Aucun système ne fait partie de ce domaine',
    'relatedEntitiesCard.emptyHelpLinkTitle': 'Apprendre comment changer cela',
    'systemDiagramCard.title': 'Diagramme du système',
    'systemDiagramCard.description':
      'Utilisez le pincement et le zoom pour vous déplacer dans le diagramme.',
    'systemDiagramCard.edgeLabels.dependsOn': 'dépend de',
    'systemDiagramCard.edgeLabels.partOf': 'fait partie de',
    'systemDiagramCard.edgeLabels.provides': 'fournit',
    'catalogExportButton.errorMessage':
      "Échec de l'export du catalogue : {{errorMessage}}",
    'catalogExportButton.cancelButtonTitle': 'Annuler',
    'catalogExportButton.dialogTitle':
      'Exporter la sélection du catalogue',
    'catalogExportButton.triggerButtonTitle': 'Exporter la sélection',
    'catalogExportButton.formatLabel': 'Format',
    'catalogExportButton.columnsLabel': 'Colonnes',
    'catalogExportButton.confirmButtonTitle': 'Confirmer',
    'catalogExportButton.exportingButtonTitle': 'Export en cours…',
    'catalogExportButton.successMessage':
      'Catalogue exporté avec succès',
  },
});
